/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Služby`
};

const da_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Tjenester`
};

const de_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Dienstleistungen`
};

const en_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Services`
};

const es_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Servicios`
};

const fr_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Services`
};

const hu_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Szolgáltatások`
};

const it_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Servizi`
};

const nl_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Diensten`
};

const pl_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Usługi`
};

const pt_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Serviços`
};

const sv_footer_services_services = /** @type {(inputs: {}) => string} */ () => {
	return `Tjänster`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const footer_services_services = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_services_services(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_services_services", locale)
	if (locale === "cs") return cs_footer_services_services(inputs)
	if (locale === "da") return da_footer_services_services(inputs)
	if (locale === "de") return de_footer_services_services(inputs)
	if (locale === "en") return en_footer_services_services(inputs)
	if (locale === "es") return es_footer_services_services(inputs)
	if (locale === "fr") return fr_footer_services_services(inputs)
	if (locale === "hu") return hu_footer_services_services(inputs)
	if (locale === "it") return it_footer_services_services(inputs)
	if (locale === "nl") return nl_footer_services_services(inputs)
	if (locale === "pl") return pl_footer_services_services(inputs)
	if (locale === "pt") return pt_footer_services_services(inputs)
	return sv_footer_services_services(inputs)
};
export { footer_services_services as "footer.services.services" }